import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Link } from 'react-router'
import Collapsible from '../collapsible'
import {
  Breadcrumb
} from 'react-bootstrap'

@observer(['globals', 'quickbooks'])
export default class Connect extends Component {

  constructor(props) {
    super(props)

    this.props.quickbooks.connect()
  }

  render() {

    const quickbooksContent = (
      <div>
        Here is where we go to connect to Quickbooks
      </div>
    )

    return (
      <div className="right_col" role="main" style={{ height: 'inherit' }}>
        <div className="">
          <div className="page-title">
            <div className="title_left">
              <Breadcrumb>
                <Link to="/">Home</Link> / Quickbooks Authorization
              </Breadcrumb>
            </div>
          </div>
          <div className="clearfix"></div>
          <Collapsible title="Quickbooks Authorization" content={ quickbooksContent } />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/quickbooks/connect.js